import { CompanyLinkTableRowType } from '../types';

export const freelancerRows: CompanyLinkTableRowType[] = [
  {
    label: 'SITE_ADDRESS',
    accessor: 'address',
  },
  {
    label: 'SITE_PHONE',
    accessor: 'contact.phone',
  },
  {
    label: 'SITE_MOBILE',
    accessor: 'contact.mobile',
  },
  {
    label: 'SITE_EMAIL',
    accessor: 'contact.email',
  },
  {
    label: 'TAGS',
    accessor: 'categories',
  },
];
